<!-- ORGANISM: AppBarActions.vue -->

<script setup lang="ts">
//
// Imports
//

// Vuetify
import { useDisplay } from "vuetify/lib/composables/display.mjs";

// Components
import OtpResultsActions from "../molecules/OtpResultsActions.vue";
import OtpBalanceActions from "../molecules/OtpBalanceActions.vue";
import AllVisitsActions from "../molecules/AllVisitsActions.vue";
import CorporateResultsActions from "../molecules/CorporateResultsActions.vue";
import PatientRecordActions from "../molecules/PatientRecordActions.vue";
import AccountMenu from "./AccountMenu.vue";

//
// Composables
//

// Breakpoints
const { smAndDown } = useDisplay();

// App Bar
const { extensionsConfig } = useAppBar();
</script>

<template>
  <div class="d-flex align-center ga-0 mr-2">
    <!-- OTP Patient Results Actions (PDF download + email) -->
    <otp-results-actions v-if="extensionsConfig.component === 'OtpResultsActions'" />

    <!-- OTP Patient Balance Actions (refresh) -->
    <otp-balance-actions v-if="extensionsConfig.component === 'OtpBalanceActions'" />

    <!-- All Visits Actions (filter + refresh) -->
    <all-visits-actions v-if="extensionsConfig.component === 'AllVisitsActions'" />

    <!-- Corporate Visit Results Actions (refresh + email + PDF) -->
    <corporate-results-actions v-if="extensionsConfig.component === 'CorporateResultsActions'" />

    <!-- Patient Record Actions (refresh) -->
    <patient-record-actions v-if="extensionsConfig.component === 'PatientRecordActions'" />

    <!-- Account Menu -->
    <account-menu />
  </div>
</template>
